'use client'

import { useEffect, useRef, useState } from 'react'

import { ProductMoreType } from '../types'
interface ToggleButtonsProps {
  data: ProductMoreType
  selectedIndex: number
  handleClick: (button: React.SetStateAction<number>) => void
}

function ToggleButtons({ data, selectedIndex, handleClick }: ToggleButtonsProps) {
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 })
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([])

  useEffect(() => {
    const currentTab = tabRefs.current[selectedIndex - 1]
    if (currentTab) {
      const { offsetLeft, offsetWidth } = currentTab
      setSliderStyle({ left: offsetLeft, width: offsetWidth })
    }
  }, [selectedIndex])

  return (
    <div className="relative inline-flex items-center overflow-hidden rounded-[100px] bg-[#F3F3F4] p-[4px] max-xl:p-[2px]">
      <div
        className="absolute left-0 top-1 h-[calc(100%-8px)] rounded-full bg-black transition-all duration-300"
        style={{
          transform: `translateX(${sliderStyle.left}px)`,
          width: `${sliderStyle.width}px`,
        }}
      />
      {data?.products?.map((item, index) => (
        <button
          onClick={() => handleClick(index + 1)}
          key={index + 1}
          ref={(el) => {
            tabRefs.current[index] = el
          }}
          className={`relative z-[1] h-[54px] rounded-[100px] px-[32px] py-[16px] font-miSansDemiBold450 transition-colors duration-200 ${selectedIndex === index + 1 ? 'text-white' : 'text-black'} max-xl:h-[32px] max-xl:px-[20px] max-xl:py-2 max-xl:text-[12px] max-xl:leading-[16px] xl:text-lg`}>
          {item?.tab_title}
        </button>
      ))}
    </div>
  )
}

export default ToggleButtons
